/**
 * Icon Component - Constants
 * ==========================
 */

/** Tamaños soportados, en px (escala del Figma de origen). */
export type IconSize = 16 | 20 | 24 | 32 | 40;

export interface IconDefaultValues {
  variant: 'linear' | 'solid';
  size: IconSize;
}

/** Mapa tamaño → clases Tailwind (w/h). */
export const SIZE_CLASSES: Record<IconSize, string> = {
  16: 'ec-w-4 ec-h-4',
  20: 'ec-w-5 ec-h-5',
  24: 'ec-w-6 ec-h-6',
  32: 'ec-w-8 ec-h-8',
  40: 'ec-w-10 ec-h-10'
};

export const VALID_SIZES: IconSize[] = [16, 20, 24, 32, 40];

export const DEFAULTS: IconDefaultValues = { variant: 'linear', size: 24 };
